const CONFIG = {
  API_URL: 'https://nmwrrd.000webhostapp.com/facebook/'
  // API_URL: 'http://localhost/facebook-vid/'
}
module.exports = CONFIG



// WEBPACK FOOTER //
// ./src/config.js